import { render, staticRenderFns } from "./nameOneRowLen.vue?vue&type=template&id=6532d2c8&scoped=true"
import script from "./nameOneRowLen.vue?vue&type=script&lang=ts"
export * from "./nameOneRowLen.vue?vue&type=script&lang=ts"
import style0 from "./nameOneRowLen.vue?vue&type=style&index=0&id=6532d2c8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6532d2c8",
  null
  
)

export default component.exports